<a class="tab" appSetActive>
  <ng-content></ng-content>
</a>
